import { createSlice } from "@reduxjs/toolkit";

export const userAccountSlice = createSlice({
  name: "userAccount",
  initialState: {
    user: null,
  },
  reducers: {
    setUserAccount: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { setUserAccount } = userAccountSlice.actions;
export default userAccountSlice.reducer;
